export default __webpack_public_path__ + "e53f30a96b5f2238455e21bc229f3299.png";